import React, { useEffect, useRef, useState } from "react";
import logger from "../utilitis/logger";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { useNavigate } from "react-router-dom";

const NotARobotCheckbox = ({
  openDialog,
  openDialogBox,
  companyNumber,
  phoneNumber,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const svgRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState(false);
  const [helpertext, setHelpertext] = useState("");
  const [errorInput, setErrorInput] = useState(false);
  const [sucess, setSucess] = useState(false);
  const [button, setButton] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    openDialogBox(false);
    setIsChecked(false);
    setInputValue("");
    setErrorInput(false);
    setHelpertext("");
  };

  const handleCheckboxChange = async (event) => {
    setIsChecked(event.target.checked);
    if (event.target.checked === true) {
      try {
        const response = await axios.get(`/humanity_test`, {
          withCredentials: true,
        });
        if (response.status === 200) {
          svgRef.current.innerHTML = response.data;
        }
      } catch (error) {
        if (error.response.status == 403) {
          navigate("/");
        }
      }
    } else {
      setError(true);
    }
  };

  const sendAgain = async (event) => {
    try {
      const response = await axios.get(`/humanity_test`, {
        withCredentials: true,
      });
      if (response.status === 200) {
        svgRef.current.innerHTML = response.data;
      }
    } catch (error) {
      if (error.response.status == 403) {
        navigate("/");
      }
    }
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const checkInput = async () => {
    setButton(true);
    try {
      const response = await axios.post(`/validate_captcha`, {
        withCredentials: true,
        captcha: inputValue,
      });
      if (response.status === 200) {
        setErrorInput(false);
        setHelpertext("");
        handlesumbit();
      }
      setButton(false);
    } catch (error) {
      logger.error("Error fetching data:", error);
      if (error.response.status === 400) {
        setErrorInput(true);
        setHelpertext("נא נסה שוב ");
        sendAgain();
      } else if (error.response.status == 403) {
        navigate("/");
      }
      setButton(false);
    }
  };

  const handlesumbit = async () => {
    try {
      const response = await axios.post(`/req_to_open_contact`, {
        withCredentials: true,
        wtaxnum: companyNumber,
        phone: phoneNumber,
      });
      if (response.status === 200) {
        setErrorInput(false);
        setHelpertext("הבקשה נשלחה בהצלחה");
        setSucess(true);
        setTimeout(() => {
          handleClose();
        }, 6000);
      }
    } catch (error) {
      if (error.response.status === 404) {
        setErrorInput(true);
        setHelpertext("מספר חברה אינו תקין   ");
        sendAgain();
      } else if (error.response.status == 403) {
        navigate("/");
      }
    }
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <FormControl required error={error}>
          <FormGroup>
            <FormControlLabel
              style={{ flexDirection: "row-reverse", paddingLeft: "2.4rem" }}
              labelPlacement="end"
              control={
                <Checkbox
                  required
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  color="primary"
                />
              }
              label="אני לא רובוט"
            />
          </FormGroup>
          {error ? <FormHelperText>נא ללחוץ על ה</FormHelperText> : null}
        </FormControl>
      </DialogContent>
      {isChecked ? (
        <DialogContent>
          <div style={{ float: "right" }} ref={svgRef} />
          <div></div>
          <TextField
            helperText={helpertext}
            error={errorInput}
            label="ערך"
            value={inputValue}
            onChange={handleInputChange}
            variant="outlined"
            size="small"
            margin="normal"
            color={sucess ? "success" : ""}
            focused={sucess}
          />
        </DialogContent>
      ) : null}
      <DialogActions>
        <Button onClick={handleClose}>לסגור</Button>
        {isChecked ? (
          <Button
            disabled={button}
            variant="contained"
            color="primary"
            onClick={checkInput}
          >
            שליחה
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

export default NotARobotCheckbox;
